import { useEffect, useMemo, useState } from 'react';
import './App.css';

import Header from './components/Header';
import BurgerMenu from './components/BurgerMenu';
import SideBar from './components/SideBar';
import Footer from './components/Footer';
import WhatsAppIcon from './components/WhatsAppIcon';

import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import Products from './pages/Products';
import CarbFinder from './pages/CarbFinder';

const NAV_ITEMS = [
  { label: 'Home', path: '/' },
  { label: 'Products', path: '/products' },
  { label: 'Carb Finder', path: '/carb-finder' },
  { label: 'About Us', path: '/about-us' },
  { label: 'Contact', path: '/contact' },
];

function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname || '/');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname || '/');
      setIsMenuOpen(false);
      setIsSidebarOpen(false);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen || isSidebarOpen ? 'hidden' : 'auto';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMenuOpen, isSidebarOpen]);

  const navigateTo = (path) => {
    window.history.pushState({}, '', path);
    setCurrentPath(window.location.pathname || '/');
    setIsMenuOpen(false);
    setIsSidebarOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const activePage = useMemo(() => {
    switch (currentPath) {
      case '/products':
        return <Products />;
      case '/carb-finder':
        return <CarbFinder />;
      case '/about-us':
        return <AboutUs />;
      case '/contact':
        return <Contact />;
      case '/':
      default:
        return <Home />;
    }
  }, [currentPath]);

  return (
    <div className="app-shell">
      <Header
        navItems={NAV_ITEMS}
        currentPath={currentPath}
        onNavigate={navigateTo}
        onMenuToggle={() => setIsMenuOpen((prev) => !prev)}
        onSidebarToggle={() => setIsSidebarOpen((prev) => !prev)}
      />

      <BurgerMenu
        isOpen={isMenuOpen}
        navItems={NAV_ITEMS}
        currentPath={currentPath}
        onNavigate={navigateTo}
        onClose={() => setIsMenuOpen(false)}
      />

      <SideBar
        isOpen={isSidebarOpen}
        navItems={NAV_ITEMS}
        currentPath={currentPath}
        onNavigate={navigateTo}
        onClose={() => setIsSidebarOpen(false)}
      />

      <main className="app-main">{activePage}</main>

      <WhatsAppIcon />
      <Footer navItems={NAV_ITEMS} onNavigate={navigateTo} />
    </div>
  );
}

export default App;
